import { Injectable, EventEmitter } from '@angular/core';
import { Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { UserManager, User, WebStorageStateStore, UserManagerEvents } from 'oidc-client';
import { urls } from '../../../assets/constants.json';

const settings: any = {
  authority: urls.idpBaseUrl,
  client_id: 'bidesClientId@3$#!',
  redirect_uri: `${urls.clientBaseUrl}${urls.idp.redirect}`,
  post_logout_redirect_uri: `${urls.clientBaseUrl}${urls.idp.postLogoutRedirect}`,
  response_type: 'id_token token',
  scope: 'openid profile IdentityServerApi api1',
  silent_redirect_uri: `${urls.clientBaseUrl}${urls.idp.silentRedirect}`,
  automaticSilentRenew: true,
  loadUserInfo: true,
  prompt: 'none',
  userStore: new WebStorageStateStore({store: localStorage})
};

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
	mgr: UserManager = new UserManager(settings);
	userLoadededEvent: EventEmitter<User> = new EventEmitter<User>();
	public currentUser: User;
	public loggedIn = false;
	authHeaders: Headers;

	constructor() {
		this.mgr.getUser()
			.then((user) => {
				console.log(user);
				if (!!user) {
					this.loggedIn = true;
					this.currentUser = user;
					this.currentUser.profile.role = JSON.parse(this.currentUser.profile.role);
					this.currentUser.profile.invalid_user = !!this.currentUser.profile.invalid_user;
					this.userLoadededEvent.emit(user);
				} else {
					this.loggedIn = false;
				}
			})
			.catch((err) => {
				this.loggedIn = false;
			});

		this.mgr.events.addUserLoaded((user) => {
			this.currentUser = user;
			this.currentUser.profile.role = JSON.parse(this.currentUser.profile.role);
			this.currentUser.profile.invalid_user = !!this.currentUser.profile.invalid_user;
		});

		this.mgr.events.addUserUnloaded(() => {
			this.loggedIn = false;
		});

		this.mgr.events.removeUserSignedOut(() => {
			this.loggedIn = false;
		});

		this.mgr.events.addAccessTokenExpired((e) => {
			this.mgr.signinSilent();
		});

		this.mgr.events.addSilentRenewError(function (err) {
		});
		this.mgr.events.addUserSignedOut(function () {
		});
	}

	isLoggedInObs(): Observable<boolean> {
		return Observable.fromPromise(this.mgr.getUser()).map<User, boolean>((user) => {
			return !!user;
		});
	}

	clearState() {
		return this.mgr.clearStaleState().then(function () {
			console.log('clearStateState success');
		}).catch(function (e) {
			console.log('clearStateState error', e.message);
		});
	}

	getUser() {
		return this.mgr.getUser().then((user) => {
			this.currentUser = user;
			this.currentUser.profile.role = JSON.parse(this.currentUser.profile.role);
			this.currentUser.profile.invalid_user = !!this.currentUser.profile.invalid_user;
			console.log('got user', user);
			this.userLoadededEvent.emit(user);
		}).catch(function (err) {
			console.log(err);
		});
	}

	removeUser() {
		return this.mgr.removeUser().then(() => {
			this.userLoadededEvent.emit(null);
			console.log('user removed');
		}).catch(function (err) {
			console.log(err);
		});
	}

	startSigninMainWindow() {
		this.mgr.signinRedirect({ data: 'some data' }).then(function () {
			console.log('signinRedirect done');
		}).catch(function (err) {
			console.log(err);
		});
	}
	endSigninMainWindow() {
		this.mgr.signinRedirectCallback().then(function (user) {
			console.log('signed in', user);
		}).catch(function (err) {
			console.log(err);
		});
	}

	startSignoutMainWindow() {

	}

	endSignoutMainWindow() {
		this.mgr.signoutRedirectCallback().then(function (resp) {
			console.log('signed out', resp);
		}).catch(function (err) {
			console.log(err);
		});
	}

	logout() {
		this.removeUser();
		this.clearState();
		this.mgr.signoutRedirect();
	}
}
